// extracted by mini-css-extract-plugin
export default {"coverTheEachHere":"investmentPlans_coverTheEachHere__AKN1s","absoluteDelete":"investmentPlans_absoluteDelete__hJUQf","coverTheMap":"investmentPlans_coverTheMap__ukoLi"};